import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const EmailSubjectLine = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12709"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12709)">
          <rect
            x="-2"
            y="-2"
            width="119"
            height="114"
            rx="5.13625"
            fill="#ECF2FF"
          />
          <path
            d="M68.2971 77.1851C68.483 81.614 69.9419 85.8955 72.499 89.5165H54.8435C57.3982 85.8945 58.8559 81.6135 59.0424 77.1851H68.2971Z"
            fill="#E3E3E3"
          />
          <path
            d="M99.1256 67.9365V74.1022C99.1256 74.9199 98.8008 75.704 98.2227 76.2821C97.6446 76.8603 96.8604 77.1851 96.0428 77.1851H31.3028C30.4852 77.1851 29.7011 76.8603 29.1229 76.2821C28.5448 75.704 28.22 74.9199 28.22 74.1022V67.9365H99.1256Z"
            fill="white"
          />
          <path
            d="M99.1256 21.6936V67.9364H28.22V21.6936C28.22 20.8759 28.5448 20.0918 29.1229 19.5137C29.7011 18.9355 30.4852 18.6107 31.3028 18.6107H96.0428C96.8604 18.6107 97.6446 18.9355 98.2227 19.5137C98.8008 20.0918 99.1256 20.8759 99.1256 21.6936Z"
            fill="#66E1FF"
          />
          <path
            d="M28.22 21.6936V67.9364H41.6766L91.0023 18.6107H31.3028C30.4852 18.6107 29.7011 18.9355 29.1229 19.5137C28.5448 20.0918 28.22 20.8759 28.22 21.6936Z"
            fill="#C2F3FF"
          />
          <path
            d="M77.5395 34.0251H49.7938C48.9762 34.0251 48.192 34.3499 47.6139 34.9281C47.0357 35.5062 46.7109 36.2904 46.7109 37.108V52.5223C46.7109 53.3399 47.0357 54.124 47.6139 54.7022C48.192 55.2803 48.9762 55.6051 49.7938 55.6051H77.5395C78.3571 55.6051 79.1413 55.2803 79.7194 54.7022C80.2976 54.124 80.6223 53.3399 80.6223 52.5223V37.108C80.6223 36.2904 80.2976 35.5062 79.7194 34.9281C79.1413 34.3499 78.3571 34.0251 77.5395 34.0251Z"
            fill="#E3E3E3"
          />
          <path
            d="M49.7999 34.0251C48.9823 34.0251 48.1981 34.3499 47.62 34.9281C47.0418 35.5062 46.717 36.2904 46.717 37.108V52.5223C46.717 53.3399 47.0418 54.124 47.62 54.7022C48.1981 55.2803 48.9823 55.6051 49.7999 55.6051H54.008L75.588 34.0251H49.7999Z"
            fill="white"
          />
          <path
            d="M77.5456 34.0251H49.7999C48.9823 34.0251 48.1981 34.3499 47.62 34.9281C47.0418 35.5062 46.717 36.2904 46.717 37.108V52.5223C46.717 53.3399 47.0418 54.124 47.62 54.7022C48.1981 55.2803 48.9823 55.6051 49.7999 55.6051H77.5456C78.3632 55.6051 79.1474 55.2803 79.7255 54.7022C80.3036 54.124 80.6284 53.3399 80.6284 52.5223V37.108C80.6284 36.2904 80.3036 35.5062 79.7255 34.9281C79.1474 34.3499 78.3632 34.0251 77.5456 34.0251Z"
            stroke="#191919"
            strokeWidth="0.987611"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M46.717 38.6494L60.5899 45.74C61.5272 46.2811 62.5904 46.566 63.6727 46.566C64.7551 46.566 65.8183 46.2811 66.7556 45.74L80.6284 38.6494"
            stroke="#191919"
            strokeWidth="0.987611"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.8496 89.5165C57.4043 85.8945 58.862 81.6135 59.0485 77.1851"
            stroke="#191919"
            strokeWidth="0.987611"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.4957 89.5165C69.941 85.8945 68.4833 81.6135 68.2969 77.1851"
            stroke="#191919"
            strokeWidth="0.987611"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.7998 89.5165H77.5455"
            stroke="#191919"
            strokeWidth="0.987611"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.22 67.9365H99.1256"
            stroke="#191919"
            strokeWidth="0.987611"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M96.0428 18.6107H31.3028C30.4852 18.6107 29.7011 18.9355 29.1229 19.5137C28.5448 20.0918 28.22 20.8759 28.22 21.6936V74.1021C28.22 74.9197 28.5448 75.7039 29.1229 76.282C29.7011 76.8602 30.4852 77.185 31.3028 77.185H96.0428C96.8604 77.185 97.6446 76.8602 98.2227 76.282C98.8008 75.7039 99.1256 74.9197 99.1256 74.1021V21.6936C99.1256 20.8759 98.8008 20.0918 98.2227 19.5137C97.6446 18.9355 96.8604 18.6107 96.0428 18.6107Z"
            stroke="#191919"
            strokeWidth="0.987611"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.6587 25.0937C11.6587 24.73 11.9534 24.4353 12.3171 24.4353H59.7224C60.086 24.4353 60.3808 24.73 60.3808 25.0937V36.0891C60.3808 36.4527 60.086 36.7475 59.7224 36.7475H12.3171C11.9534 36.7475 11.6587 36.4527 11.6587 36.0891V25.0937Z"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.31681"
          />
          <path
            d="M14.551 28.6191V27.9735C14.551 27.8022 14.619 27.638 14.7401 27.517C14.8612 27.3959 15.0254 27.3279 15.1966 27.3279H19.7157C19.8869 27.3279 20.0512 27.3959 20.1722 27.517C20.2933 27.638 20.3613 27.8022 20.3613 27.9735V28.6191"
            stroke="#1E1E1E"
            strokeWidth="1.31681"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.4558 27.3279V33.1382"
            stroke="#1E1E1E"
            strokeWidth="1.31681"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.1653 33.1381H18.7476"
            stroke="#1E1E1E"
            strokeWidth="1.31681"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.1189 33.4608H27.8575"
            stroke="#1E1E1E"
            strokeWidth="1.31681"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
